export class MenuNode {
    public id: string;
    public label: string;
    public key: string;
    public link: string;
    public isOldSetup: boolean;
    public isVisible: boolean;
    public active?: boolean;
    public isDisabled?: boolean;
    /** If we want to make active side link that is different than selected node */
    public activeNodeId?: string;
}

export class MenuParentNode extends MenuNode {
    public children: Array<MenuNode>;
    public isCollapsed?: boolean;
    public active?: boolean;
}

export enum MenuInfoLinks {
    ChangeSet = 1,
    TenantUrl = 2
}